<form style="margin: auto;">
    <textarea
      #textarea
      matInput
      placeholder="Add your note here..."
      style="border: 0.81px solid rgba(211, 220, 232, 0.7);"
      class="full-width rounded-lg resize-none p-3.5 box-border"
      rows="8"
      [(ngModel)]="note"
      maxlength="200"
      [value]="note ? note : ''"
      (input)="checkNote($event.target.value)"
    >
    </textarea>
  </form>
  <br />
  <p class="my-0 ml-0 mr-4 text-right text-[#707070]">{{ note.length + ' / 200' }}</p>


